// extracted by mini-css-extract-plugin
export default {"removeButton":"RemoveButton_removeButton__6chG0","iconColor":"RemoveButton_iconColor__XhWKB"};